import { render, staticRenderFns } from "./main.vue?vue&type=template&id=f28d5598&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=f28d5598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28d5598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f28d5598')) {
      api.createRecord('f28d5598', component.options)
    } else {
      api.reload('f28d5598', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=f28d5598&scoped=true&", function () {
      api.rerender('f28d5598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/zxx/components/main.vue"
export default component.exports